import { Observable } from 'rxjs/Observable';
import { Case } from '../../beans/Case';
import { Lawyer } from '../../beans/Lawyer';
import { Nomenclature } from '../../beans/Nomenclature';
import { StatusesTask } from '../../beans/StatusesTask';
import { AuthService } from '../../services/auth.service';
import { BlockUiService } from '../../services/blockui.service';
import { CaseService } from '../../services/case.service';
import { NomenclatureService } from '../../services/nomenclature.service';
import { urlLinks } from '../../utility/url-links';
import { DatePipe } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewContainerRef, Host, ViewChild, HostListener } from '@angular/core';
import { NgForm } from '@angular/forms';
import { RequestOptions } from '@angular/http';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { ModalDirective } from 'ngx-bootstrap';
import { CompleterService, CompleterData, RemoteData } from 'ng2-completer';

@Component({
	selector: 'app-edit-case',
	templateUrl: './edit-case.component.html',
	styleUrls: ['./edit-case.component.scss']
})
export class EditCaseComponent implements OnInit {

	@ViewChild('caseModal') public childModal: ModalDirective;
	@ViewChild('caseForm') public clientForm: NgForm;
	private tabset: NgbTabset;


	editedCase: Case;
	errorMessage = '';
	isAdmin = false;

	instances: Array<Nomenclature>;
	cities: Array<Nomenclature>;
	courts: Array<Nomenclature>;
	statuses: Array<Nomenclature>;
	nakazatelniStatuses: Array<Nomenclature>;
	statusesTask: Array<StatusesTask>;
	lawyers: Array<Lawyer>;
	damageTypes: Array<Nomenclature>;
	traumaType: Array<Nomenclature>;

	constructor(
		private caseService: CaseService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private nomenclatureService: NomenclatureService,
		private datePipe: DatePipe,
		private authService: AuthService
	) {
		this.isAdmin = this.authService.isUserAdmin();
	}

	ngOnInit() {
		this.caseService.caseSaved$.subscribe(caseId => {
			this.reloadForId(caseId);
		});
	}

	private loadNomenclatures() {
		this.loadInstance();
		this.loadCities();
		this.loadCourts();
		this.loadStatuses();
		this.loadNakazatelniStatuses();
		this.loadStatusesTask();
		this.loadLawyers();
		this.loadDamageTypes();
		this.loadTraumaTypes();
	}

	private loadStatuses() {
		this.statuses = new Array<Nomenclature>();
		this.nomenclatureService.getStatuses().subscribe(lst => {
			this.statuses = lst;
		},
			error => {
			});
	}

	private loadDamageTypes() {
		this.damageTypes = new Array<Nomenclature>();
		this.nomenclatureService.getDamageTypes().subscribe(types => {
			this.damageTypes = types;
		},
			error => {
			});
	}

	private loadTraumaTypes() {
		this.traumaType = new Array<Nomenclature>();
		this.nomenclatureService.getTraumaTypes().subscribe(types => {
			this.traumaType = types;
		},
			error => {
			});
	}

	private loadLawyers() {
		this.nomenclatureService.getLawyers().subscribe(
			lawyers => {
				this.lawyers = lawyers;
			},
			error => {
			});
	}

	private loadCourts() {
		this.courts = new Array<Nomenclature>();
		this.nomenclatureService.getCourts().subscribe(lst => {
			this.courts = lst;
		},
			error => {
			});
	}

	private loadNakazatelniStatuses() {
		this.nakazatelniStatuses = new Array<Nomenclature>();
		this.nomenclatureService.getNakazatelnoStatuses().subscribe(lst => {
			this.nakazatelniStatuses = lst;
		},
			error => {
			});
	}

	private loadCities() {
		this.cities = new Array<Nomenclature>();
		this.nomenclatureService.getCities().subscribe(lst => {
			this.cities = lst;
		},
			error => {
			});
	}

	private loadInstance() {
		this.instances = new Array<Nomenclature>();
		this.nomenclatureService.getInstances().subscribe(lst => {
			this.instances = lst;
		},
			error => {
			});
	}

	private loadStatusesTask() {
		this.statusesTask = new Array<StatusesTask>();
		this.nomenclatureService.getStatusesTask().subscribe(lst => {
			for (let i = 0; i < lst.length; i++) {
				this.statusesTask[i] = new StatusesTask();
				this.statusesTask[i].name = lst[i];
				let statusTaskBG = '';
				switch (this.statusesTask[i].name) {
					case 'NOVA': {
						statusTaskBG = 'НОВА';
						break;
					}
					case 'V_PROCESS': {
						statusTaskBG = 'В ПРОГРЕС';
						break;
					}
					case 'IZPULNEN': {
						statusTaskBG = 'ИЗПЪЛНЕНА';
						break;
					}
				}
				this.statusesTask[i].bgName = statusTaskBG;
			}
		},
			error => {
			});
	}

	@ViewChild('tabset')
	public set _tabs(tabs: NgbTabset) {
		if (tabs) {
			this.tabset = tabs;
		}
	}

	public setError(error: string) {
		this.errorMessage = error;
	}

	public editCase(caseObj: Case): void {
		this.loadNomenclatures();
		this.reloadForId(caseObj.id);
		this.childModal.show();
		if (this.tabset) {
			this.tabset.select('main-tab');
		}
	}

	public createCase(caseObj: Case): void {
		this.loadNomenclatures();
		this.editedCase = new Case();
		this.childModal.show();
		if (this.tabset) {
			this.tabset.select('main-tab');
		}
	}

	public close(): void {
		this.blockUi.stop();
		this.childModal.hide();
	}

	@HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
		if (event.key === 'Escape') {
			this.close();
		}
	}
	public reload() {
		this.reloadForId(this.editedCase.id);
	}

	public reloadForId(caseId: number) {
		this.blockUi.start(this.vcRef);
		this.caseService.getCase(caseId).subscribe(
			result => {
				this.editedCase = result;
				if (result.date != null) { this.editedCase.date = this.datePipe.transform(new Date(result.date), 'dd.MM.yyyy'); }
				if (result.claimDate != null) { this.editedCase.claimDate = this.datePipe.transform(new Date(result.claimDate), 'dd.MM.yyyy'); }
				this.blockUi.stop();
			},
			error => {
				this.blockUi.stop();
			});
	}

	formatDate(dateToFormat): Date {
		if (dateToFormat) {
			if (typeof dateToFormat === 'string' || dateToFormat instanceof String) {
				let dateParts: string[] = dateToFormat.split('.');
				//month is 0-based, that's why we need dataParts[1] - 1
				return new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]), 12, 0, 0, 0);
			}
			return dateToFormat;
		}
		return;
	}

	editCaseFromDelo(row) {
		this.loadNomenclatures();
		this.reloadForId(row.id);
		this.childModal.show();
		if (this.tabset) {
			this.tabset.select('main-tab');
		}
	}

	editCaseFromTask(row) {
		this.loadNomenclatures();
		this.reloadForId(row.lawsuiteId);
		this.childModal.show();
		if (this.tabset) {
			this.tabset.select('main-tab');
		}
	}

	editCaseFromNotification(lawsuiteId: number) {
		this.loadNomenclatures();
		this.reloadForId(lawsuiteId);
		this.childModal.show();
		if (this.tabset) {
			this.tabset.select('main-tab');
		}                   
	}

}
